// App.tsx
import { Suspense } from 'react';
import './App.css';
import { useAuth } from './utils/AuthContext';
import BottomSection from './components/bottomSection/BottomSection';

// ⬅️ Import the component wrapper instead of the router object
import AppRoutes from './routes/appRoutes';

function App() {
  const { user } = useAuth();
  const path = window.location.pathname;

  return (
    <Suspense fallback="loading...">
      <div className={user ? 'app-layout-user' : 'app-layout'}>
        <div className="app-container">
          {/* Renders <RouterProvider router={...}/> internally */}
          <AppRoutes />
        </div>
      </div>
      {!user && path === '/' && <BottomSection />}
    </Suspense>
  );
}

export default App;
